
import { resetTypes } from "../../ActionTypes/resetTypes";
import {ResetActions, ResetState } from "../../types/type";



const initialState: ResetState = {
  pending: false,
  password: [],
  error: null,
};

export default (state = initialState, action: ResetActions,) => {
  switch (action.type) {
    case resetTypes.FETCH_RESET_REQUEST:
      return {
        ...state,
        pending: false
      };
    case resetTypes.FETCH_RESET_SUCCESS:
      return {
        ...state,
        pending: true,
        password: action.payload.password,
        error: null
      };
    case resetTypes.FETCH_RESET_FAILURE:
      return {
        ...state,
        pending: false,
        password: [],
        error: action.payload.error
      };
    default:
      return {
        ...state
      };
  }
};
